export * from '../AccountApp/AccountApp';



/** WEBPACK FOOTER **
 ** ./account.js
 **/